import { Injectable } from '@angular/core';
import {
    Router,
    Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { BooksService } from '../../../../features/accounting/books/state/books.service';
import { BooksQuery } from '../../../../features/accounting/books/state/books.query';
import { distinctUntilChanged, filter, map, pluck, switchMap } from 'rxjs/operators';
import { filterNilValue } from '@datorama/akita';
import { Book } from '../../../../features/accounting/books/state/book.model';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { LegalEntityQuery } from '../../../admin/state/legal-entities/legal-entity.query';

@Injectable({
    providedIn: 'root'
})
export class AccountingBookResolver implements Resolve<any> {
    constructor(
        private bookService: BooksService,
        private bookQuery: BooksQuery,
        private _ownersQuery: LegalEntityQuery
    ) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        // TODO: fix logic for this resolver based on owner? And resolve when data has loaded
        return this.bookQuery.selectLoading().pipe(
            filter((loading) => !loading),
            switchMap((finishedLoading) => this.bookQuery.selectAllWithOwner$()),
            map((books) => {
                if (books.length > 0) {
                    this.bookService.setActive(books[0].id);
                }
                return {
                    options: books,
                    value$: this.bookQuery.activeBook$.pipe(
                        pluck('id'),
                        distinctUntilChanged(),
                        filterNilValue()
                    ),
                    onChange: (
                        change: MatSelectChange & {
                            value: Book['id'];
                        }
                    ) => {
                        this.bookService.setActive(change.value);
                    },
                    config: {
                        displayKey: 'ownerName',
                        valueKey: 'id'
                    }
                };
            })
        );
    }
}
